<h3 class="mt-0 mb-12">{{ selectedFilter.translationKey | translate }}</h3>
<mat-form-field class="w-100-p">
    <mat-label>{{ 'GENERAL.PROPERTY.CHOOSE_DATE' | translate }}</mat-label>
    <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRange">
        <input matStartDate formControlName="startDate" />
        <input matEndDate formControlName="endDate" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker
        #picker
        [restoreFocus]="false"
        (opened)="onRangePickerOpened()"
        (closed)="onRangePickerClosed()"
    ></mat-date-range-picker>
</mat-form-field>
